import React, { useState } from 'react';
import axios from 'axios';
import { CONSTANTS } from '../../constants';

const GiphySearch = ({ onClose }) => {
  const [giphySearch, setGiphySearch] = useState('');
  const [searching, setSearching] = useState(false);
  const [giphyData, setGiphyData] = useState([]);
  const [error, setError] = useState('');

  const search = async () => {
    if (!giphySearch || giphySearch === undefined || giphySearch === 'undefined') {
      setError('Please enter a keyword you want to search giphy for.');
      return;
    }

    if (giphySearch.length < 3) {
      setError('Please enter a keyword longer than 2 letters.');
      return;
    }

    setSearching(true);
    setError('');

    const queryParams = {
      q: giphySearch,
      api_key: CONSTANTS.GIPHY.API_KEY,
      limit: 10,
      offset: 0,
      lang: 'en',
      rating: 'PG-13'
    };

    try {
      const response = await axios.get(CONSTANTS.GIPHY.SEARCH_ENDPOINT, { params: queryParams });
      setGiphyData(response.data.data);

      if (!response.data.data.length) {
        setError(`Sorry, there were no gifs related to ${giphySearch}`);
      }
    } catch (error) {
      setError('There was an error getting gifs from giphy, please try again later.');
    } finally {
      setSearching(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      search();
    }
  };

  const resetSearch = () => {
    setGiphySearch('');
    setGiphyData([]);
    setError('');
  };

  return (
    <div>
      <div className="mb-3">
        <label htmlFor="giphySearch" className="form-label">Search for GIFs:</label>
        <input
          type="text"
          className="form-control"
          id="giphySearch"
          value={giphySearch}
          onChange={(e) => setGiphySearch(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Enter a keyword (minimum 3 characters)"
        />
      </div>

      <div className="mb-3">
        <button 
          className="btn btn-primary me-2"
          onClick={search}
          disabled={searching || !giphySearch.trim() || giphySearch.length < 3}
        >
          {searching ? 'Searching...' : 'Search GIFs'}
        </button>
        
        <button 
          className="btn btn-secondary"
          onClick={resetSearch}
        >
          Reset
        </button>
      </div>

      {error && (
        <div className="alert alert-danger">
          {error}
        </div>
      )}

      {giphyData.length > 0 && (
        <div className="mt-4">
          <h5>Search Results for "{giphySearch}"</h5>
          <div className="row">
            {giphyData.map((gif, index) => (
              <div key={index} className="col-md-6 col-lg-4 mb-3">
                <div className="card">
                  <img 
                    src={gif.images.fixed_height.url} 
                    className="card-img-top" 
                    alt={gif.title}
                    style={{ height: '200px', objectFit: 'cover' }}
                  />
                  <div className="card-body">
                    <h6 className="card-title" style={{ fontSize: '14px' }}>
                      {gif.title.length > 50 ? gif.title.substring(0, 50) + '...' : gif.title}
                    </h6>
                    <p className="card-text">
                      <small className="text-muted">
                        From: {gif.username || 'Anonymous'}
                      </small>
                    </p>
                    <a 
                      href={gif.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn btn-sm btn-outline-primary"
                    >
                      View on Giphy
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="mt-4">
        <h6>Instructions:</h6>
        <ol>
          <li>Enter a search term (minimum 3 characters)</li>
          <li>Click "Search GIFs" or press Enter</li>
          <li>Browse through the results</li>
          <li>Click "View on Giphy" to see the original</li>
        </ol>
      </div>
    </div>
  );
};

export default GiphySearch;
